import { Axios } from './Axios';

export async function getClassOverview(orgId) {
  const url = `stats/overview?orgId=${orgId}`;
  return Axios({
    url,
    method: 'get'
  });
}
